import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { TrendingUp } from 'lucide-react';

const TimelineButton = ({ className = '' }) => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate('/timeline')}
      variant="outline"
      size="sm"
      className={`text-xs rounded-full border-primary/30 text-primary hover:bg-primary/10 px-2 sm:px-3 ${className}`}
      data-testid="timeline-insights-btn"
    >
      <TrendingUp className="w-3.5 h-3.5 mr-1" />
      <span className="hidden sm:inline">Timeline & Insights</span>
      <span className="sm:hidden">Timeline</span>
    </Button>
  );
};

export default TimelineButton;
